// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_oCb","cls2":"Comments-cls2_zKq Comments-cls1_oCb"};